module.exports = __webpack_public_path__ + "img/icon1_1.eaca558f.png";